import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router'
import queryString from 'query-string'
import { Community } from '../../../models'
import Routes from '../../../startup/routes'
import { isEmbedded } from '../../../util/window'
import CalendarContainer from '../../containers/misc/CalendarContainer'
import EmbeddedModalLinkBlocker from '../misc/EmbeddedModalLinkBlocker'
import FilterByCommunity from '../misc/FilterByCommunity'
import FilterByAgeRange from '../misc/FilterByAgeRange'
import EventSignUpUpsell from './EventSignUpUpsell'

type Props = {
  communities?: Community[]
  blockedEventCommunities?: string[]
  selectedDay: Date
  toggleEventCommunity?: React.ChangeEventHandler<HTMLInputElement>
  selectedAgeRanges: string[]
  setSelectedAgeRanges: (ageRanges: string[]) => void
}
const EventsListSidebar: React.FC<Props> = ({ 
  communities, 
  blockedEventCommunities, 
  selectedDay, 
  toggleEventCommunity, 
  selectedAgeRanges,
  setSelectedAgeRanges 
}) => {
  const history = useHistory()
  const location = useLocation()

  const handleAgeRangeToggle = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const ageRangeValue = event.target.name
    const isChecked = event.target.checked
    
    let newSelectedAgeRanges: string[]
    if (isChecked) {
      newSelectedAgeRanges = [...selectedAgeRanges, ageRangeValue]
    } else {
      newSelectedAgeRanges = selectedAgeRanges.filter(range => range !== ageRangeValue)
    }
    
    setSelectedAgeRanges(newSelectedAgeRanges)
    
    // Update URL parameters
    const currentQuery = queryString.parse(location.search)
    const newQuery = {
      ...currentQuery,
      ...(newSelectedAgeRanges.length > 0 ? { ageRanges: newSelectedAgeRanges.join(',') } : {}),
    }
    
    // Remove ageRanges param if no ranges selected
    if (newSelectedAgeRanges.length === 0) {
      delete newQuery.ageRanges
    }
    
    const newSearch = queryString.stringify(newQuery)
    history.push({
      pathname: location.pathname,
      search: newSearch
    })
  }, [selectedAgeRanges, setSelectedAgeRanges, history, location])

  return (
  <aside>
    <EmbeddedModalLinkBlocker
      to={Routes.newEvent()}
      className="btn btn-red btn-new submit-event"
      modalComponent={EventSignUpUpsell}
      modalCTALink={Routes.signUp(communities?.[0])}
    >
      Submit an Event
    </EmbeddedModalLinkBlocker>

    <CalendarContainer selectedDay={selectedDay} />

    {communities && communities.length > 1 && !isEmbedded() && blockedEventCommunities && toggleEventCommunity && (
      <FilterByCommunity communities={communities} blockedCommunities={blockedEventCommunities} handleToggle={toggleEventCommunity} />
    )}
    
    {!isEmbedded() && (
      <FilterByAgeRange selectedAgeRanges={selectedAgeRanges} handleToggle={handleAgeRangeToggle} />
    )}
  </aside>
  )
}

export default EventsListSidebar
